import { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { ListForm, InfoPopup } from "components/ui";

const GRID = "1fr 1fr 100px";

const FormOfContactField = ({
  setFieldValue,
  preferred_foc,
  insurance_focs,
  insurances,
  form_of_contacts,
}) => {
  const [itemToAdd, setItemToAdd] = useState({
    insurance_id: "",
    foc_id: "",
  });

  const insuranceNameFor = (id) =>
    insurances?.find((x) => x.id === id)?.name ?? id;
  const focNameFor = (id) =>
    form_of_contacts?.find((x) => x.value === id)?.text ?? id;

  // One form of contact per insurance; re-adding a mapped insurance replaces it.
  const addItem = () => {
    setFieldValue("insurance_focs", [
      itemToAdd,
      ...insurance_focs.filter((x) => x.insurance_id !== itemToAdd.insurance_id),
    ]);
    setItemToAdd({ insurance_id: "", foc_id: "" });
  };

  return (
    <div style={{ padding: 15, border: "1px solid #ccc" }}>
      <h1 style={{ textAlign: "center" }}>
        Form Of Contact
        <InfoPopup>
          Resolved in this order: the form_of_contact column on the import file,
          then the autoship flag, then the insurance override below, then the
          preferred list. Bad Phone Number/Contact info will allow updating
          patients form of contact if we get contact info from file down the
          road
        </InfoPopup>
      </h1>

      <h3 style={{ marginBottom: 4 }}>Override By Insurance</h3>
      <div style={{ color: "#666", fontSize: "0.85em", marginBottom: 10 }}>
        A patient whose primary insurance is one of these uses the mapped form
        of contact. If the patient is not eligible for it (no email on file, no
        text permission, and so on) the import falls back to the preferred list
        below and records a warning on the import log.
      </div>

      <div
        style={{ display: "grid", gridTemplateColumns: GRID, gridGap: 20 }}
      >
        <div>Insurance</div>
        <div>Form Of Contact</div>
        <div />
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: GRID,
          gridGap: 20,
          padding: 20,
        }}
      >
        <select
          value={itemToAdd.insurance_id}
          onChange={(e) =>
            setItemToAdd({ ...itemToAdd, insurance_id: e.target.value })
          }
        >
          <option value="">Select Insurance</option>
          {insurances?.map((x) => (
            <option key={x.id} value={x.id}>
              {x.name}
            </option>
          ))}
        </select>
        <select
          value={itemToAdd.foc_id}
          onChange={(e) =>
            setItemToAdd({ ...itemToAdd, foc_id: e.target.value })
          }
        >
          <option value="">Select Form Of Contact</option>
          {form_of_contacts?.map((x) => (
            <option key={x.value} value={x.value}>
              {x.text}
            </option>
          ))}
        </select>
        <Button
          type="button"
          disabled={!itemToAdd.insurance_id || !itemToAdd.foc_id}
          onClick={addItem}
        >
          Add
        </Button>
      </div>

      <div style={{ maxHeight: 240, overflowY: "auto" }}>
        {insurance_focs?.length === 0 && (
          <div style={{ padding: 20, textAlign: "center", color: "#999" }}>
            No insurances mapped — every patient uses the preferred list below.
          </div>
        )}
        {insurance_focs?.map((x) => (
          <div
            key={x.insurance_id}
            style={{
              display: "grid",
              gridTemplateColumns: GRID,
              gridGap: 20,
              padding: 5,
            }}
          >
            <div>{insuranceNameFor(x.insurance_id)}</div>
            <div>{focNameFor(x.foc_id)}</div>
            <Button
              type="button"
              onClick={() =>
                setFieldValue(
                  "insurance_focs",
                  insurance_focs.filter(
                    (y) => y.insurance_id !== x.insurance_id,
                  ),
                )
              }
            >
              Delete
            </Button>
          </div>
        ))}
      </div>

      <hr />

      <div style={{ fontSize: "20px" }}>
        <ListForm
          fieldName="preferred_foc"
          options={form_of_contacts.map((x) => ({ id: x.value, name: x.text }))}
          setFieldValue={setFieldValue}
          label="Preferred Form Of Contact"
          list={preferred_foc}
          sortable
        />
      </div>
      <div style={{ color: "#666", fontSize: "0.85em" }}>
        Used when the insurance has no override, or when the patient is not
        eligible for the one it has. Tried top to bottom.
      </div>
    </div>
  );
};

FormOfContactField.defaultProps = {};

FormOfContactField.propTypes = {
  setFieldValue: PropTypes.func,
  preferred_foc: PropTypes.array,
  insurance_focs: PropTypes.array,
  insurances: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  form_of_contacts: PropTypes.array,
};

export default FormOfContactField;
